import React, { useEffect, useState } from "react";

import { Modal, DatePicker, IconWrapper, TextArea, TextField, Typography } from "@king-ict/eupisi-ui/components";
import { ReactComponent as CloseIcon } from "@king-ict/eupisi-ui/components/Icon/CloseBig.svg";
import {
  useValidation,
  useDisableBodyScroll,
  enableBodyScroll,
} from "@king-ict/eupisi-ui/hooks";
import { DocumentData } from "@king-ict/eupisi-ui/models";
import { nameof } from "@king-ict/eupisi-ui/utils";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { OtherLegalEntityInfo } from "../../features/ProgramRequestEdit/OtherLegalEntityInfo";
import { useInput } from "../../hooks";
import { OtherLegalEntityLocation } from "../../models/ProgramRequest";
import { OtherLegalEntityLocationValidationScheme } from "../../models/ProgramRequest/OtherLegalEntityLocationValidationScheme";

export interface OtherLegalEntityLocationModalProps {
    open: boolean;
    disableBody?: boolean;
    value: OtherLegalEntityLocation;
    confirmText: string;
    cancelText: string;
    onClose?: () => void;
    onConfirm: (item: OtherLegalEntityLocation) => void;

};

export const OtherLegalEntityLocationModal = ({open, value, confirmText, cancelText, disableBody = true, onClose, onConfirm}: OtherLegalEntityLocationModalProps) => {
    useDisableBodyScroll(disableBody, open);

    const { t } = useTranslation();
    const { handleChange } = useInput();
    const [otherLegalEntityLocationInternal, setOtherLegalEntityLocationInternal] = useState<OtherLegalEntityLocation>(value);
    const [errors, doValidations] = useValidation({
      data: otherLegalEntityLocationInternal,
      validationSchema: OtherLegalEntityLocationValidationScheme,
    });
  
    useEffect(() => {
        //unmount
        return () => {
          enableBodyScroll();
        };
    }, []);

    useEffect(() => {
        if (value) {
            setOtherLegalEntityLocationInternal(value);
        }
    }, [value]);

    const getOtherLegalEntityLocationErrorForPath = (path: string): string | undefined => {    
        path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
        path = path.replace(/^\.*/, '');           // strip a leading dot
        var pathKeys = path.split('.');
        var result = errors as any;
    
        for (let i = 0; i < pathKeys.length; ++i) {
          var key = pathKeys[i];
          if (result && typeof (result) === 'object' && result.hasOwnProperty(key)) {
            result = result[key] as any;
          } else {
            return undefined;
          }
        }    
        return result as string;
    };

    const handleConfirmClick = () => {
        const isValid = doValidations();
        if (!isValid) return;

        onConfirm(otherLegalEntityLocationInternal)
    };
    
    const handleItemChange = (e: any) => {
        const item = e.target.value as OtherLegalEntityLocation;
        setOtherLegalEntityLocationInternal(item);
    };

    if (!open || !otherLegalEntityLocationInternal) return null;

    return (
        <Modal
            type="confirm"
            variant="big"
            open={open}
            confirmText={confirmText}
            cancelText={cancelText}
            onClose={() => onClose ? onClose() : null}
            onConfirm={handleConfirmClick}
        >
            <OtherLegalEntityInfo 
                name="."
                otherLegalEntityLocation={otherLegalEntityLocationInternal} 
                onChange={handleItemChange}
                getErrorForPath={getOtherLegalEntityLocationErrorForPath}
            />
        </Modal>
     );
    
}